// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, updateNotificationSettingClient } from "../../Utils/Constants";
import { toast } from "react-toastify";


export const hitUpdateNotificationSettingClientApi = createAsyncThunk("hitUpdateNotificationSettingClientApi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("clientToken")}`,
      },
    };
    const url = ApiBaseUrl + updateNotificationSettingClient;
    const response = await axios.put(url, payload, config);
    return response.data;
  } catch (error) {
    toast.error(error.response.data.message);
    throw error.response.data;
  }
});

const UpdateNotificationSettingClientSlice = createSlice({
  name: "updateNotificationSettingClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitUpdateNotificationSettingClientData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitUpdateNotificationSettingClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitUpdateNotificationSettingClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitUpdateNotificationSettingClientApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitUpdateNotificationSettingClientData } = UpdateNotificationSettingClientSlice.actions;
export default UpdateNotificationSettingClientSlice.reducer;
